import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-e8d365f0"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  style: {
    "text-align": "center",
    "margin": "15px 0"
  }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_cell = _resolveComponent("van-cell");
  const _component_van_field = _resolveComponent("van-field");
  const _component_van_cell_group = _resolveComponent("van-cell-group");
  const _component_AttachmentCpt = _resolveComponent("AttachmentCpt");
  const _component_PopupDatePickerCpt = _resolveComponent("PopupDatePickerCpt");
  const _component_DataPickerCpt = _resolveComponent("DataPickerCpt");
  const _component_CodeDataPickerCpt = _resolveComponent("CodeDataPickerCpt");
  const _component_van_button = _resolveComponent("van-button");
  const _component_van_form = _resolveComponent("van-form");
  const _component_PageNavBackLayoutCpt = _resolveComponent("PageNavBackLayoutCpt");
  return _openBlock(), _createBlock(_component_PageNavBackLayoutCpt, {
    class: "page"
  }, {
    default: _withCtx(() => [_createVNode(_component_van_form, {
      onSubmit: $options.onSubmit
    }, {
      default: _withCtx(() => [_createVNode(_component_van_cell_group, {
        title: "基本信息"
      }, {
        default: _withCtx(() => [_createVNode(_component_van_cell, {
          title: "预约单号",
          value: $data.form.appointmentNo
        }, null, 8, ["value"]), _createVNode(_component_van_cell, {
          title: "交易号码",
          value: $data.form.tradeNo
        }, null, 8, ["value"]), $data.form.tradeId ? (_openBlock(), _createBlock(_component_van_cell, {
          key: 0,
          title: "认购日期",
          value: $data.form.subscriptionDate
        }, null, 8, ["value"])) : _createCommentVNode("", true), !$data.form.tradeId ? (_openBlock(), _createBlock(_component_van_field, {
          key: 1,
          modelValue: $data.form.subscriptionDate,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.form.subscriptionDate = $event),
          required: "",
          "input-align": "right",
          "error-message-align": "right",
          name: "subscriptionDate",
          label: "认购日期",
          placeholder: "请输入认购日期",
          rules: [{
            required: true,
            message: '请输入认购日期'
          }],
          onClick: _cache[1] || (_cache[1] = $event => $options.onPopupDateTimeSelectClick('subscriptionDate'))
        }, null, 8, ["modelValue"])) : _createCommentVNode("", true), _createVNode(_component_van_cell, {
          title: "理财顾问",
          value: $data.form.branchName + ' ' + $data.form.agentName
        }, null, 8, ["value"])]),
        _: 1
      }), _createVNode(_component_van_cell_group, {
        title: "产品信息"
      }, {
        default: _withCtx(() => [_createVNode(_component_van_cell, {
          title: "产品名称",
          value: $data.form.productName
        }, null, 8, ["value"]), _createVNode(_component_van_cell, {
          title: "成立日",
          value: $data.form.foundDate
        }, null, 8, ["value"]), _createVNode(_component_van_cell, {
          title: "认申购额",
          value: $data.form.subscriptionAmount
        }, null, 8, ["value"]), $data.form.openDate || $data.form.openDateOn ? (_openBlock(), _createBlock(_component_van_cell, {
          key: 0,
          title: "开放日",
          value: $data.form.openDate
        }, null, 8, ["value"])) : _createCommentVNode("", true), $data.form.beneficialType || $data.form.beneficialTypeOn ? (_openBlock(), _createBlock(_component_van_field, {
          key: 1,
          modelValue: $data.form.beneficialTypeText,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $data.form.beneficialTypeText = $event),
          clickable: "",
          required: "",
          "input-align": "right",
          "error-message-align": "right",
          name: "beneficialTypeText",
          label: "受益权类型",
          placeholder: "受益权类型",
          rules: [{
            required: true,
            message: '请选择受益权类型'
          }],
          onClick: _cache[3] || (_cache[3] = $event => $options.onCodeDataPickerSelectClick('beneficialType'))
        }, null, 8, ["modelValue"])) : _createCommentVNode("", true), $data.form.reductionRate || $data.form.reductionRateOn ? (_openBlock(), _createBlock(_component_van_field, {
          key: 2,
          modelValue: $data.form.reductionRate,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => $data.form.reductionRate = $event),
          required: "",
          "input-align": "right",
          "error-message-align": "right",
          rules: [{
            required: true,
            message: '请输入减免比例'
          }],
          name: "reductionRate",
          label: "减免比例(%)",
          placeholder: "请输入减免比例(%)"
        }, null, 8, ["modelValue"])) : _createCommentVNode("", true), $data.form.payTime || $data.form.payTimeOn ? (_openBlock(), _createBlock(_component_van_cell, {
          key: 3,
          title: "私募打款时间",
          value: $data.form.payTime
        }, null, 8, ["value"])) : _createCommentVNode("", true)]),
        _: 1
      }), _createVNode(_component_van_cell_group, {
        title: "客户信息"
      }, {
        default: _withCtx(() => [_createVNode(_component_van_cell, {
          title: "客户姓名",
          value: $data.form.chnName
        }, null, 8, ["value"]), _createVNode(_component_van_cell, {
          title: "客户号",
          value: $data.form.customerNo
        }, null, 8, ["value"]), _createVNode(_component_van_cell, {
          title: "性别",
          value: _ctx.formatSelectColumn($data.codeResItems, 'sex', {
            sex: $data.form.sex
          })
        }, null, 8, ["value"]), _createVNode(_component_van_cell, {
          title: "出生日期",
          value: $data.form.birthday
        }, null, 8, ["value"]), _createVNode(_component_van_cell, {
          title: "联系电话",
          value: $data.form.mobile
        }, null, 8, ["value"]), _createVNode(_component_van_cell, {
          title: "邮箱",
          value: $data.form.email
        }, null, 8, ["value"]), _createVNode(_component_van_cell, {
          title: "证件类型",
          value: _ctx.formatSelectColumn($data.codeResItems, 'idType', {
            idType: $data.form.idType
          })
        }, null, 8, ["value"]), _createVNode(_component_van_cell, {
          title: "证件号码",
          value: $data.form.idNo
        }, null, 8, ["value"]), _createVNode(_component_van_cell, {
          title: "证件有效期",
          value: $data.form.idEndDate
        }, null, 8, ["value"]), _createVNode(_component_van_cell, {
          title: "年龄",
          value: $data.form.age
        }, null, 8, ["value"])]),
        _: 1
      }), _createVNode(_component_van_cell_group, {
        title: "银行账户信息"
      }, {
        default: _withCtx(() => [!$data.form.tradeId ? (_openBlock(), _createBlock(_component_van_field, {
          key: 0,
          modelValue: $data.form.bankName,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => $data.form.bankName = $event),
          clickable: "",
          required: "",
          "input-align": "right",
          "error-message-align": "right",
          name: "bankName",
          label: "开户行",
          placeholder: "开户行(如没有请到客户信息维护菜单)",
          rules: [{
            required: true,
            message: '请选择开户行(如没有请到客户信息维护菜单)'
          }],
          onClick: _cache[6] || (_cache[6] = $event => $options.onpickerDataSelectClickBank('bankId'))
        }, null, 8, ["modelValue", "rules"])) : _createCommentVNode("", true), _createVNode(_component_van_field, {
          modelValue: $data.form.bankBranchName,
          "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => $data.form.bankBranchName = $event),
          readonly: "",
          "input-align": "right",
          "error-message-align": "right",
          name: "bankBranchName",
          label: "分行名称",
          placeholder: "分行名称"
        }, null, 8, ["modelValue"]), _createVNode(_component_van_field, {
          modelValue: $data.form.accountHolder,
          "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => $data.form.accountHolder = $event),
          readonly: "",
          "input-align": "right",
          "error-message-align": "right",
          name: "accountHolder",
          label: "开户名",
          placeholder: "开户名"
        }, null, 8, ["modelValue"]), _createVNode(_component_van_field, {
          modelValue: $data.form.cardNo,
          "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => $data.form.cardNo = $event),
          readonly: "",
          "input-align": "right",
          "error-message-align": "right",
          name: "cardNo",
          label: "开户账号",
          placeholder: "开户账号"
        }, null, 8, ["modelValue"])]),
        _: 1
      }), _createVNode(_component_van_cell_group, {
        title: "地址信息"
      }, {
        default: _withCtx(() => [$data.form.auditStatus != '01' ? (_openBlock(), _createBlock(_component_van_cell, {
          key: 0,
          title: "详细地址",
          value: $data.form.street
        }, null, 8, ["value"])) : _createCommentVNode("", true), $data.form.auditStatus === '01' ? (_openBlock(), _createBlock(_component_van_field, {
          key: 1,
          modelValue: $data.form.street,
          "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => $data.form.street = $event),
          required: "",
          "input-align": "right",
          "error-message-align": "right",
          type: "textarea",
          name: "street",
          label: "详细地址",
          placeholder: "详细地址",
          rules: [{
            required: true,
            message: '请选择详细地址'
          }],
          onClick: _cache[11] || (_cache[11] = $event => $options.onpickerDataSelectClickAdress('street'))
        }, null, 8, ["modelValue"])) : _createCommentVNode("", true)]),
        _: 1
      }), _createVNode(_component_van_cell_group, {
        title: "其他信息"
      }, {
        default: _withCtx(() => [$data.form.tradeId ? (_openBlock(), _createBlock(_component_van_cell, {
          key: 0,
          title: "附件",
          "is-link": "",
          to: {
            name: 'attachmentDetail',
            params: {
              businessId: $data.form.tradeId,
              attachmentType: $data.attachmentType,
              flag: this.attachFlag
            }
          }
        }, null, 8, ["to"])) : _createCommentVNode("", true), $data.form.tradeId ? (_openBlock(), _createBlock(_component_van_cell, {
          key: 1,
          title: "申请进度",
          "arrow-direction": "",
          "is-link": "",
          to: {
            name: 'workFlowDetail',
            params: {
              businessId: $data.form.tradeId,
              workFlowDefinitionId: 6
            }
          }
        }, null, 8, ["to"])) : _createCommentVNode("", true)]),
        _: 1
      }), _createVNode(_component_AttachmentCpt, {
        ref: "AttachmentCpt1"
      }, null, 512), _createVNode(_component_AttachmentCpt, {
        isShow: $data.show,
        ref: "AttachmentCpt"
      }, null, 8, ["isShow"]), _createVNode(_component_PopupDatePickerCpt, {
        ref: "PopupDateTimeCpt",
        onOnSelectedChange: $options.onDateTimeSelectedChange
      }, null, 8, ["onOnSelectedChange"]), _createVNode(_component_DataPickerCpt, {
        ref: "DataPickerCpt",
        columnsFieldNames: $data.columnsFieldNames,
        onOnSelectedChange: $options.onPickerDataSelected
      }, null, 8, ["columnsFieldNames", "onOnSelectedChange"]), _createVNode(_component_CodeDataPickerCpt, {
        ref: "CodeDataPickerCpt",
        onOnSelectedChange: $options.onCodeDataPickerSelected
      }, null, 8, ["onOnSelectedChange"]), _createElementVNode("div", _hoisted_1, [$data.form.auditStatus == '01' ? (_openBlock(), _createBlock(_component_van_button, {
        key: 0,
        style: {
          "width": "22%",
          "margin-right": "5px"
        },
        type: "primary",
        loading: $data.btnLoading,
        "native-type": "submit"
      }, {
        default: _withCtx(() => [_createTextVNode(" 保存 ")]),
        _: 1
      }, 8, ["loading"])) : _createCommentVNode("", true), $data.form.auditStatus == '01' && $data.form.tradeId ? (_openBlock(), _createBlock(_component_van_button, {
        key: 1,
        style: {
          "width": "22%",
          "margin-right": "5px"
        },
        type: "primary",
        loading: $data.btnLoading,
        onClick: $options.onAuditSubmit
      }, {
        default: _withCtx(() => [_createTextVNode(" 提交复核 ")]),
        _: 1
      }, 8, ["loading", "onClick"])) : _createCommentVNode("", true), $data.form.auditStatus == '01' && $data.form.tradeId ? (_openBlock(), _createBlock(_component_van_button, {
        key: 2,
        style: {
          "width": "22%"
        },
        "native-type": "button",
        type: "primary",
        loading: $data.btnLoading,
        onClick: $options.onTradeInputCancle
      }, {
        default: _withCtx(() => [_createTextVNode(" 撤销 ")]),
        _: 1
      }, 8, ["loading", "onClick"])) : _createCommentVNode("", true)])]),
      _: 1
    }, 8, ["onSubmit"])]),
    _: 1
  });
}